<template>
  <div class="content">
    <div class="echarts">
      <IEcharts
          :option="option"
      />
    </div>
  </div>
</template>
<script>

export default {
  name: 'SpeedGauge',
  props: ['speed', 'iface', 'mode'],
  data () {
    // const that = this
    return {
      ins: null,
      echarts: null,
      load: true,
      show: false,
      data: [],
      cur_type: 'middle'
    }
  },

  computed: {
    speed_now(){
      return (this.speed/1024/1024).toFixed(2)
    },

    option () {
      return {
        series: [
          {
            name: 'Speed',
            type: 'gauge',
            progress: {
              show: true
            },
            title: {
              offsetCenter: ['0%', '100%'],
              show: true,
              fontSize: 18,
              fontWeight: 'bolder',
              color: '#777'
            },
            axisLabel: {
              color: '#777',
            },
            axisLine: {
              lineStyle: {
                color: [
                  [0.05, '#EB5E28'],
                  [1, '#41B883']
                ]
              }
            },
            animationDurationUpdate: 1500,
            detail: {
              lineHeight: 160,
              height: 40,
              offsetCenter: [0, '35%'],
              valueAnimation: true,
              formatter: function (value) {
                return '{value|' + value.toFixed(2) + '}{unit|Mb/s}';
              },
              rich: {
                value: {
                  fontSize: 40,
                  fontWeight: 'bolder',
                  color: '#777'
                },
                unit: {
                  fontSize: 20,
                  color: '#999',
                  padding: [0, 0, 0, 10]
                }
              }
            },
            data: [
              {
                value: this.speed_now,
                name: `${this.iface}: ${this.mode}`
              }
            ]
          }
        ]
      }
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.card{
  padding: 10px;
  overflow: hidden;
  .header{
    padding: 10px 0;
    z-index: 2;
    cursor: pointer;
    .title{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      span{
        color: #999;
        font-size: 14px;
        font-weight: 600;
        margin-left: 5px;
      }
    }
  }
  .content{
    transition: 0.3s;
    opacity: 1;
    height: auto;
    z-index: 1;
    &.hide_block{
      opacity: 0;
      height: 0;
      padding: 0;
      z-index: 0;
    }
    .toggle_button{
      z-index: 10;
      margin-bottom: 20px;
    }
    .echarts {
      width: 99%;
      height: 690px;
      margin-top: -40px;
      margin-bottom: -12px;
    }
  }
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
